import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, BellRing, Radio, LineChart, MessageCircle, Smartphone, Share2, CheckCircle2, ArrowRight } from "lucide-react";

const FEATURES = [
  [Radio, "Free Gold & Bitcoin updates", "Har naya Fateh FX signal aur update turant app me"],
  [BellRing, "Instant phone alerts", "App band ho tab bhi signal aur badi news ka alert"],
  [LineChart, "Chart analysis", "Order Blocks, FVG aur indicators ka AI analysis"],
  [MessageCircle, "Fateh AI chat", "Lot size, risk, broker — kuch bhi puchiye"],
];
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export default function GetApp() {
  const [prompt, setPrompt] = useState(() => window.__fxInstall || null);
  const [done, setDone] = useState(standalone());
  useEffect(() => {
    const on = () => setPrompt(window.__fxInstall);
    const installed = () => setDone(true);
    window.addEventListener("fx-installable", on);
    window.addEventListener("appinstalled", installed);
    return () => { window.removeEventListener("fx-installable", on); window.removeEventListener("appinstalled", installed); };
  }, []);
  const install = async () => {
    prompt.prompt();
    const r = await prompt.userChoice;
    if (r?.outcome === "accepted") setDone(true);
    window.__fxInstall = null;
    setPrompt(null);
  };
  const link = `${window.location.origin}/app`;
  const share = () => (navigator.share ? navigator.share({ title: "Fateh FX App", text: "Free Gold & Bitcoin signals app", url: link }).catch(() => {})
    : window.open(`https://wa.me/?text=${encodeURIComponent(`Fateh FX app install karo — free Gold & Bitcoin signals: ${link}`)}`, "_blank"));

  return (
    <div className="min-h-screen grain" style={{ background: "var(--app-bg)" }} data-testid="get-app-page">
      <header className="max-w-5xl mx-auto px-5 pt-6 flex items-center gap-2">
        <img src="/icons/icon-192.png" alt="" className="w-8 h-8" />
        <span className="font-head font-bold text-white">Fateh FX</span>
        <Link to="/login" className="ml-auto text-xs text-slate-400 hover:text-white transition-colors duration-200" data-testid="get-app-login">Login</Link>
      </header>
      <main className="max-w-5xl mx-auto px-5 py-12 grid lg:grid-cols-2 gap-12 items-center">
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
          <div className="text-[11px] uppercase tracking-[0.25em] text-gold flex items-center gap-2"><Smartphone size={13} />Android & iPhone app</div>
          <h1 className="font-head font-bold text-white text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05]">Fateh FX<br /><span className="text-gold">App download karein</span></h1>
          <p className="text-slate-400 mt-5 max-w-md text-sm sm:text-base">Free Gold & Bitcoin updates, instant alerts aur AI chat — sab ek app me. Play Store ki zaroorat nahi, 5 second me install.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            {done ? (
              <div className="flex items-center gap-2 px-6 py-3.5 border border-bull text-bull text-sm" data-testid="get-app-installed"><CheckCircle2 size={18} />App install ho gaya</div>
            ) : prompt ? (
              <button onClick={install} data-testid="get-app-install-btn" className="flex items-center gap-2 px-7 py-3.5 bg-gold text-black font-bold rounded-full hover:brightness-110 hover:-translate-y-0.5 transition-[filter,transform] duration-200"><Download size={18} />Install Android App</button>
            ) : (
              <a href="#steps" data-testid="get-app-steps-btn" className="flex items-center gap-2 px-7 py-3.5 bg-gold text-black font-bold rounded-full hover:brightness-110 transition-[filter] duration-200"><Download size={18} />Install kaise karein</a>
            )}
            <button onClick={share} data-testid="get-app-share-btn" className="flex items-center gap-2 px-5 py-3.5 border border-[color:var(--border-subtle)] text-slate-200 rounded-full hover:border-gold hover:text-gold transition-colors duration-200"><Share2 size={16} />Share link</button>
          </div>
          <Link to="/login?signup=1" className="mt-6 inline-flex items-center gap-1 text-sm text-gold hover:underline" data-testid="get-app-signup">Free account banayein <ArrowRight size={14} /></Link>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {FEATURES.map(([Icon, t, d], i) => (
            <div key={t} className="surface p-5 animate-in fade-in slide-in-from-bottom-2 duration-500" style={{ animationDelay: `${150 + i * 90}ms`, animationFillMode: "both" }}>
              <Icon size={20} className="text-gold" />
              <div className="text-white font-semibold mt-3 text-sm">{t}</div>
              <div className="text-xs text-slate-500 mt-1">{d}</div>
            </div>
          ))}
        </div>
      </main>
      <section id="steps" className="max-w-5xl mx-auto px-5 pb-16 grid md:grid-cols-2 gap-4" data-testid="get-app-instructions">
        <div className={`surface p-6 ${isIOS() ? "opacity-60" : ""}`}>
          <div className="font-head text-white">Android (Chrome)</div>
          <ol className="text-sm text-slate-400 mt-3 space-y-2 list-decimal list-inside">
            <li>Chrome me <span className="text-gold">{link.replace(/^https?:\/\//, "")}</span> kholiye</li>
            <li>Upar "Install Android App" dabaiye, ya ⋮ menu → <b className="text-white">Install app</b></li>
            <li>Home screen pe Fateh FX icon aa jayega</li>
          </ol>
        </div>
        <div className={`surface p-6 ${!isIOS() ? "opacity-80" : ""}`}>
          <div className="font-head text-white">iPhone (Safari)</div>
          <ol className="text-sm text-slate-400 mt-3 space-y-2 list-decimal list-inside">
            <li>Safari me ye page kholiye</li>
            <li>Neeche Share button → <b className="text-white">Add to Home Screen</b></li>
            <li>App kholkar "Phone alerts" ON karein</li>
          </ol>
        </div>
      </section>
    </div>
  );
}
